import { ActionContext, ActionTree, GetterTree } from "vuex";

const initialState: any = {
  seibiLoading: false,
  seibiError: "",
  seibiAK3Loading: false,
  seibiAK3Error: "",
  shohiyouLoading: false,
  shohiyouError: "",
  couponLoading: false,
  couponError: false,
  optionLoading: false,
  optionError: false,
};

const actions: ActionTree<any, any> = {
  setLoading({ commit }: ActionContext<any, any>, payload: any): void {
    commit("setLoading", payload);
  },
  setError({ commit }: ActionContext<any, any>, payload: any): void {
    commit("setError", payload);
  },
  clearState({ commit }: ActionContext<any, any>): void {
    commit("clearState");
  }
};

const mutations = {
  setLoading(state: any, payload: any) {
    state[payload.key + "Loading"] = payload.value;
  },
  setError(state: any, payload: any) {
    state[payload.key + "Error"] = payload.value;
  },
  clearState(state: any) {
    Object.assign(state, { ...initialState });
  }
};

const getters: GetterTree<any, any> = {
  seibiLoading(state: any) {
    return state.seibiLoading;
  },
  seibiError(state: any) {
    return state.seibiError;
  },
  seibiAK3Loading(state: any) {
    return state.seibiAK3Loading;
  },
  seibiAK3Error(state: any) {
    return state.seibiAK3Error;
  },
  shohiyouLoading(state: any) {
    return state.shohiyouLoading;
  },
  shohiyouError(state: any) {
    return state.shohiyouError;
  },
  couponLoading(state: any) {
    return state.couponLoading;
  },
  couponError(state: any) {
    return state.couponError;
  },
  optionLoading(state: any) {
    return state.optionLoading;
  },
  optionError(state: any) {
    return state.optionError;
  }
};

const namespaced: boolean = true;
export default {
  namespaced,
  state: { ...initialState },
  getters,
  actions,
  mutations
};
